//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
import { Trans, withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import {
  About,
  OurBrands,
  ContactUs,
  FollowUs,
  FooterBottom,
  Logo,
} from '@cmp/common';
import { handleGtmEvent } from '@helpers/gtm';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class FooterSection extends React.Component {
  handleClick(event) {
    if (event.target.tagName.toLowerCase() === 'a') {
      const clickUrl = event.target?.href?.includes('http')
        ? event.target.href
        : window.location.origin + event.target.href;

      handleGtmEvent('navigation', {
        eventParameters: {
          omnibus: true,
          nav_group: 'footer',
          click_text: event.target.innerHTML,
          click_url: clickUrl,
        },
      });
    }

    if (event.target.tagName.toLowerCase() === 'img') {
      const clickUrl = event.target.parentElement.href;

      handleGtmEvent('navigation', {
        eventParameters: {
          omnibus: true,
          nav_group: 'footer',
          click_text: event.target.alt,
          click_url: clickUrl,
        },
      });
    }
  }

  render() {
    const { t } = this.props;

    return (
      <div
        className={styles.Footer}
        onClick={(event) => this.handleClick(event)}
      >
        <div className={styles.FooterContent}>
          <div className={styles.FooterTop}>
            <Logo
              wrapperClassName={styles.BottomLogoWrapper}
              className={styles.BottomLogo}
            />
            <About />
            <OurBrands />
            {t('trust_arc_locale') !== 'ja' && <ContactUs />}
            <FollowUs />
          </div>
          <FooterBottom className={styles.FooterBottom} />
        </div>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(FooterSection);
